import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

(() => {
  if (!document.querySelector("[data-rc-font]")) {
    const fonts = document.createElement("link");
    fonts.rel = "stylesheet";
    fonts.href =
      "https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap";
    fonts.setAttribute("data-rc-font", "");
    document.head.appendChild(fonts);
  }
})();

const style = document.createElement("style");
style.textContent = `
  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(24px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeIn {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  .nav-card {
    cursor: pointer;
    transition: transform 0.35s cubic-bezier(0.34, 1.4, 0.64, 1);
  }
  .nav-card:hover {
    transform: translateY(-6px);
  }
  .nav-card:hover .card-inner {
    border-color: #1A6FDB !important;
    box-shadow: 0 20px 48px -8px rgba(26,111,219,0.14) !important;
  }
  .nav-card:hover .card-top-bar {
    width: 100% !important;
  }
  .nav-card:hover .card-arrow {
    transform: translateX(5px);
    color: #1A6FDB !important;
  }
  .nav-card:hover .card-icon-wrap {
    background: #1A6FDB !important;
    color: #ffffff !important;
    border-color: #1A6FDB !important;
  }
  .card-top-bar {
    transition: width 0.45s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .card-arrow {
    transition: transform 0.3s ease, color 0.3s ease;
  }
  .card-icon-wrap {
    transition: background 0.3s ease, color 0.3s ease, border-color 0.3s ease;
  }
  .card-inner {
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
  }
`;
if (!document.querySelector("[data-nav-styles]")) {
  style.setAttribute("data-nav-styles", "");
  document.head.appendChild(style);
}
const C = {
  blue: "#1A6FDB",
  blueDark: "#0F4FA8",
  blueLight: "#EBF3FF",
  blueMid: "#C7DCFF",
  green: "#16A34A",
  greenLight: "#DCFCE7",
  greenMid: "#BBF7D0",
  white: "#FFFFFF",
  gray50: "#F8FAFC",
  gray100: "#F1F5F9",
  gray200: "#E2E8F0",
  gray400: "#94A3B8",
  gray600: "#475569",
  gray900: "#0F172A",
};

const IconDashboard = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  </svg>
);
const IconAnalytics = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
  </svg>
);
const IconSettings = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);
const IconArrow = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);
const NAV_OPTIONS = [
  {
    title: "Public-Private recruitment and staffing",
    description:
      "Your central overview for recruitment reporting. Monitor key employment metrics, track hiring activity, and stay informed very quickly.",
    icon: <IconDashboard />,
    path: "/reporting-form",
    tag: "Start",
    number: "01",
    accent: C.blue,
    accentLight: C.blueLight,
    accentMid: C.blueMid,
  },
  // {
  //   title: "Digital Job matching",
  //   description:
  //     "Explore skills matching reports in depth. Visualize trends, and support informed decisions",
  //   icon: <IconAnalytics />,
  //   path: "/skills-matching",
  //   tag: "Start",
  //   number: "02",
  //   accent: C.green,
  //   accentLight: C.greenLight,
  //   accentMid: C.greenMid,
  // },
  // {
  //   title: "Work-Based Learning Matching",
  //   description:
  //     "Manage your account, preferences, and configuration. Keep everything running exactly your way.",
  //   icon: <IconSettings />,
  //   path: "/settings",
  //   tag: "Start",
  //   number: "03",
  //   accent: C.blue,
  //   accentLight: C.blueLight,
  //   accentMid: C.blueMid,
  // },
];
const NavigationPage = () => {
  const [mounted, setMounted] = useState(false);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [comingPage, setComingPage] = useState("");
  const [campany, setCampany] = useState(() => {
    try {
      const companyData = localStorage.getItem("companyData");
      return companyData ? JSON.parse(companyData) : {};
    } catch (error) {
      console.error("Error parsing user data:", error);
      return {};
    }
  });

  useEffect(() => {
    const companyData = localStorage.getItem("companyData");

    if (!companyData) {
      navigate("/recruiting-company-welcome-page");
    }
  }, [navigate]);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 60);
    return () => clearTimeout(t);
  }, []);

  const handleNavigate = (path) => {
    const availableRoutes = ["/reporting-form"];

    if (availableRoutes.includes(path)) {
      navigate(path);
    } else {
      setComingPage(path);
      setOpenModal(true);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: C.gray50,
        fontFamily: "'DM Sans', sans-serif",
        display: "flex",
        flexDirection: "column",
        overflowX: "hidden",
      }}
    >
      <div
        style={{
          background: `linear-gradient(90deg, ${C.blueDark} 0%, ${C.blue} 60%, ${C.green} 100%)`,
          height: 4,
          flexShrink: 0,
        }}
      />
      <main
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "72px 24px 80px",
        }}
      >
        <div
          style={{
            textAlign: "center",
            maxWidth: 560,
            marginBottom: 60,
            opacity: mounted ? 1 : 0,
            animation: mounted ? "fadeUp 0.6s ease 0.08s both" : "none",
          }}
        >
          <h1
            style={{
              fontFamily: "'Syne', sans-serif",
              fontWeight: 800,
              fontSize: "clamp(2rem, 5vw, 3.1rem)",
              lineHeight: 1.1,
              letterSpacing: "-0.025em",
              color: C.gray900,
              margin: "0 0 8px",
            }}
          >
            {campany?.name} ready to dive in?
          </h1>
          <h2
            style={{
              fontFamily: "'Syne', sans-serif",
              fontWeight: 600,
              fontSize: "clamp(2rem, 5vw, 2.1rem)",
              lineHeight: 1.1,
              letterSpacing: "-0.025em",
              color: C.blue,
              margin: "0 0 20px",
            }}
          >
            Start your reporting now.
          </h2>
          <p
            style={{
              fontSize: "1.05rem",
              fontWeight: 400,
              color: C.gray600,
              lineHeight: 1.75,
              margin: "0 0 28px",
            }}
          >
            Choose a section below to access and manage the national database of
            job and skills matching service providers.
          </p>
        </div>
        <div
          style={{
            width: "100%",
            maxWidth: 900,
            display: "flex",
            alignItems: "center",
            gap: 14,
            marginBottom: 36,
            opacity: mounted ? 1 : 0,
            animation: mounted ? "fadeIn 0.5s ease 0.22s both" : "none",
          }}
        >
          <div style={{ flex: 1, height: 1, background: C.gray200 }} />
          <span
            style={{
              fontSize: 10,
              fontWeight: 700,
              color: C.gray400,
              fontFamily: "'Syne', sans-serif",
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              whiteSpace: "nowrap",
            }}
          >
            Select a section
          </span>
          <div style={{ flex: 1, height: 1, background: C.gray200 }} />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            maxWidth: 500,
          }}
        >
          {NAV_OPTIONS.map((opt, i) => (
            <div
              key={opt.path}
              className="nav-card"
              onClick={() => handleNavigate(opt.path)}
              style={{
                opacity: mounted ? 1 : 0,
                animation: mounted
                  ? `fadeUp 0.55s cubic-bezier(0.22, 1, 0.36, 1) ${0.22 + i * 0.1}s both`
                  : "none",
              }}
            >
              <div
                className="card-inner"
                style={{
                  background: C.white,
                  border: `1.5px solid ${C.gray200}`,
                  borderRadius: 16,
                  padding: "0 0 24px",
                  height: "100%",
                  boxSizing: "border-box",
                  position: "relative",
                  overflow: "hidden",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.04)",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    height: 3,
                    background: C.gray100,
                    position: "relative",
                    overflow: "hidden",
                    flexShrink: 0,
                  }}
                >
                  <div
                    className="card-top-bar"
                    style={{
                      height: "100%",
                      width: "0%",
                      background: opt.accent,
                    }}
                  />
                </div>
                <div
                  style={{
                    padding: "24px 24px 0",
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: 20,
                    }}
                  >
                    <span
                      style={{
                        fontFamily: "'Syne', sans-serif",
                        fontSize: 11,
                        fontWeight: 700,
                        letterSpacing: "0.12em",
                        color: C.gray400,
                      }}
                    >
                      {opt.number}
                    </span>
                    <span
                      style={{
                        fontSize: 10,
                        fontWeight: 700,
                        letterSpacing: "0.1em",
                        textTransform: "uppercase",
                        color: opt.accent,
                        background: opt.accentLight,
                        border: `1px solid ${opt.accentMid}`,
                        padding: "3px 10px",
                        borderRadius: 999,
                        fontFamily: "'Syne', sans-serif",
                      }}
                    >
                      {opt.tag}
                    </span>
                  </div>
                  <div
                    className="card-icon-wrap"
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: 12,
                      background: opt.accentLight,
                      border: `1px solid ${opt.accentMid}`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: 16,
                      color: opt.accent,
                      flexShrink: 0,
                    }}
                  >
                    {opt.icon}
                  </div>
                  <h3
                    style={{
                      fontFamily: "'Syne', sans-serif",
                      fontWeight: 700,
                      fontSize: "1.2rem",
                      letterSpacing: "-0.02em",
                      color: C.gray900,
                      margin: "0 0 8px",
                    }}
                  >
                    {opt.title}
                  </h3>
                  <p
                    style={{
                      fontSize: "0.875rem",
                      fontWeight: 400,
                      color: C.gray600,
                      lineHeight: 1.72,
                      margin: "0",
                      flex: 1,
                    }}
                  >
                    {opt.description}
                  </p>
                  <div
                    style={{
                      height: 1,
                      background: C.gray100,
                      margin: "20px 0 16px",
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: C.blue,
                      }}
                    >
                      Open section
                    </span>
                    <span
                      className="card-arrow"
                      style={{ color: C.gray400, display: "flex" }}
                    >
                      <IconArrow />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
      {openModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.60)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "28px 34px",
              borderRadius: 12,
              width: 320,
              textAlign: "center",
              boxShadow: "0 12px 40px rgba(0,0,0,0.2)",
              animation: "fadeUp 0.3s ease",
            }}
          >
            <h3
              style={{
                margin: "0 0 10px",
                fontFamily: "'Syne', sans-serif",
                fontSize: 20,
              }}
            >
              Coming Soon
            </h3>

            <p style={{ fontSize: 14, color: "#475569", marginBottom: 20 }}>
              This page will be available soon.
            </p>

            <button
              onClick={() => setOpenModal(false)}
              style={{
                background: "#1A6FDB",
                color: "#fff",
                border: "none",
                padding: "8px 18px",
                borderRadius: 6,
                cursor: "pointer",
                fontSize: 14,
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
      <footer
        style={{
          background: C.white,
          borderTop: `1px solid ${C.gray200}`,
          padding: "16px 40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexShrink: 0,
          opacity: mounted ? 1 : 0,
          animation: mounted ? "fadeIn 0.5s ease 0.4s both" : "none",
        }}
      >
        <span style={{ fontSize: 12, color: C.gray400 }}>
          © {new Date().getFullYear()} Portal. All rights reserved.
        </span>
        <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
          <div
            style={{
              width: 7,
              height: 7,
              borderRadius: "50%",
              background: C.blue,
              opacity: 0.35,
            }}
          />
          <div
            style={{
              width: 7,
              height: 7,
              borderRadius: "50%",
              background: C.blue,
              opacity: 0.65,
            }}
          />
          <div
            style={{
              width: 7,
              height: 7,
              borderRadius: "50%",
              background: C.blue,
            }}
          />
        </div>
      </footer>
    </div>
  );
};

export default NavigationPage;
